export default {
  // Allgemein

  language_picker_helper: "Veuillez choisir une langue",

  languages: {
    english: "Anglais",
    german: "Allemande",
    spanish: "Espagnol",
    french: "Français"
  },
  languagesCodes: {
    english: "GB",
    german: "DE",
    spanish: "ES",
    french: "FR"
  },

  langcodeShort: "FR",
  langcode: "fr-FR",
  messagesLanguage: "Langue de notification",
  greeting: "Bonjour",
  unexpectedError: "Une erreur inconnue est survenue.",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  sunday: "Dimanche",
  username: "Nom d'utilisateur",
  password: "Mot de passe",
  logout: "Déconnexion",
  since: "depuis",
  clock: "heures",
  oClock: "heures",
  back: "Retour",
  deviceConfig: "Afficher la configuration de l'appareil",
  active: "activé(e)",
  inactive: "désactivé(e)",
  save: "Enregistrer",
  absence: "Absence",
  requestable: "Disponible sur demande",
  unpaidAbsence: "Absence non rémunérée",
  userIsWorkingInProject: "Le collaborateur est actuellement affecté à un projet",
  all: "Tous",
  delete: "Supprimer",
  send: "Envoyer",
  date: "Date",
  search: "Rechercher",
  legend: "Legende",
  time: "Heure",
  comment: "Commentaire",
  passwordNoMatch: "Le mot de passe ne correspond pas",
  passwordTooShort: "Mot de passe trop court",
  resetPassOnLogin: "Réinitialiser le mot de passe à la connexion",
  cancel: "Annuler",
  passwordSaved: "Mot de passe enregistré",
  changePasswordQuestion: "Souhaitez-vous modifier le mot de passe ?",
  insertPassword: "Saisir le mot de passe",
  insertAdminPassword: "Saisir le mot de passe d'administrateur",
  confirmPassword: "Confirmer le mot de passe",
  confirm: "Confirmer",
  history: "Historique",
  workTime: "Temps de travail",
  pause: "Pause",
  monthlyWorkTime: "Le temps de travail mensuel s'élève à",
  showDeletedBookingLines: "Afficher les entrées supprimées",
  hideDeletedBookingLines: "Masquer les entrées supprimées",
  addTime: "Ajouter du temps",
  project: "Projet",
  add: "Ajouter",
  changeTime: "Modifier l'heure",
  timestamp: "Horodatage",
  duration: "Durée",
  coming: "Arrivée",
  going: "Départ",
  businessTrip: "Déplacement professionnel",
  startBusinessTrip: "Début déplacement professionnel",
  endBusinessTrip: "Fin déplacement professionnel",
  changeLine: "Modifier la ligne",
  timeOverlapse: "Le créneau de temps se chevauche avec celui d'une autre entrée",
  timeToBigFor: "Le créneau de temps ne doit pas dépasser",
  be: "être",
  editBookingLineWithoutComment: "Êtes-vous certain(e) de vouloir modifier une entrée sans commentaire ?",
  timeNotEntered: "Le créneau horaire n'a pas été renseigné",
  statusNotEntered: "Le statut n'a pas été renseigné",
  worktimeIs: "Le temps de travail s'élève à",
  pauseTimeIs: "Le temps de pause s'élève à",
  accept: "Accepter",
  decline: "Refuser",
  declined: "Refusé",
  reason: "Motif",
  absenceReason: "Motif d'absence",
  prevDay: "Jour précédent",
  nextDay: "Jour suivant",
  prevMonth: "Mois précédent",
  nextMonth: "Mois suivant",
  successfullyTransmitted: "Transmis avec succès",
  cobiServerNotRunning: "Serveur COBI.time : Pas de réponse",
  cobiServerUp: "Connexion au serveur COBI.time rétablie avec succès",
  finished: "Terminé(e)",
  or: "ou",
  started: "Démarré(e)",
  hours: "heures",
  activity: "Activité",
  noRight: "L'utilisateur n'a pas d'autorisation",
  publicHolidays: "Jours fériés",
  publicHoliday: "Jour férié",
  state: "Région",
  import: "Importer",
  changesWillBeLostMessage: "Toutes les modifications non enregistrées seront perdues",
  workDay: "Jour de travail",
  request: "Demander",
  select: "Sélectionner",
  month: "Mois",
  year: "Année",
  publicHolidaysLetter: "F",
  workDayLetter: "T",
  vacation: "Congé",
  changes: "Modifications",
  added: "Ajouté(e)",
  edited: "Modifié(e)",
  deleted: "Supprimé(e)",
  errorByUser: "Erreur chez l'utilisateur",
  from: "de",
  until: "à",
  attachments: "Pièces jointes",
  noBlanksError: "Espaces non autorisés",
  location: "Site",
  showAll: "Tout afficher",
  settings: "Paramètres",
  reset: "Réinitialiser",
  darkMode: "Mode sombre",
  lightMode: "Mode clair",
  resetAll: "Tout réinitialiser",
  discardSelected: "Annuler la sélection",
  timeOff: "Absence",
  half: "demi",
  halfDay: "demi-journée",
  fullDay: "journée entière",
  startValue: "Valeur initiale",
  close: "Fermer",

  // MainMenu
  avgWorkingHours: "Temps de travail moyen",
  avgBreakTime: "Temps de pause moyen",
  overtime: "Heures supplémentaires",
  nonBillableTime: "Temps non compensable",
  logoutWarning: "Êtes-vous certain(e) de vouloir vous déconnecter ?",

  // Auth
  userPin: "Code PIN utilisateur",
  resetPass: "Réinitialiser le mot de passe",
  RFIDScannerText: "Le scan a commencé",
  PleasePresentRFIDChip: "Veuillez présenter la puce RFID",
  RFIDNumberNotFound: "Numéro RFID non trouvé",
  RFIDRegistration: "Connexion par puce RFID",
  RFIDReset: "Réinitialiser la puce RFID",

  // FaceLogin.vue
  faceFound: "Visage reconnu. Essai de connexion en cours...",
  faceLoginHelp: "Veuillez ne pas bouger pendant le processus de reconnaissance faciale",
  pleaseEnterPin: "Veuillez saisir le code PIN pour vous connecter",
  enterPin: "Saisir le code PIN",
  employeeNotRecognized: "Collaborateur non identifié",
  faceLoginRestarting: "Redémarrage de la reconnaissance faciale",

  // Menu.vue
  timekeeping: "Saisie du temps",
  manualTimekeeping: "Saisie manuelle du temps",
  administration: "Gestion",
  presencelist: "Liste de présence",
  mainmenu: "Menu principal",

  // Usermenu.vue
  notifications: "Notifications",
  noNotification: "Aucune notification reçue",
  newNotification: "Nouvelles notifications",
  openNotification: "Afficher les notifications",
  unread: "Non lues",
  userFunctions: "Fonctionnalités utilisateur",
  showHistory: "Afficher l'historique",
  absenceRequest: "Demande d'absence",
  timeCorrectionRequest: "Demande de correction du temps de travail",
  noTimeBookedForThisDate: "Aucune entrée trouvée pour cette date",
  undoClue: "Êtes-vous certain(e) de vouloir annuler les modifications ?",
  deleteTimeLineClue: "Êtes-vous certain(e) de vouloir supprimer la ligne ?",

  changePic: "Modifier l'image",
  noPictureUploaded: "Aucune image n'a été téléchargée",
  profilePictureNotSaved: "L'image de profil n'a pas pu être téléchargée. (Format incorrect ou trop volumineux - 2 MB maximum)",
  messages: "Notifications",
  subject: "Objet",
  chooseMessage: "Veuillez sélectionner une notification",
  deleteMessagesQuestion: "Êtes-vous certain(e) de vouloir supprimer cette notification ?",
  markAllAsReadQuestion: "Êtes-vous certain(e) de vouloir marquer toutes les notifications comme lues ?",
  userInfo: "Données utilisateur",
  timeCorrection: "Correction de temps",
  timeCorrectionWasSuccessfulApproved: "La demande de correction de temps a été approuvée avec succès",
  timeCorrectionRequestNotFound: "La demande de correction de temps n'a pas été trouvée",

  // Status
  absent: "Absent(e)",
  present: "Présent(e)",
  inproject: "En projet",
  inpause: "En pause",
  break: "Pause",

  // Administration.vue
  userAdministration: "Gestion des utilisateurs",
  generalSettings: "Paramètres généraux",
  changeLogo: "Modifier le logo",
  resetLogo: "Réinitialiser le logo",
  upload: "Télécharger",
  absenceReasons: "Motifs d'absences",
  manage: "Gérer",
  factorAuth: "Authentification à double facteur (visage + code pin)",
  absenceAdministration: "Gestion des absences",
  importSapUser: "Importer un utilisateur SAP",
  importUser: "Importer un utilisateur",
  editUser: "Modifier un utilisateur",
  projectAdministration: "Gestion de projet",
  sapUserCodeIsMissingError: "Le code utilisateur SAP est manquant pour l'utilisateur {0}.",
  sapUserExtIdError: "Le numéro de collaborateur externe de l'utilisateur {0} est trop long.",
  userWithSameCodeError: "Un utilisateur avec le même code utilisateur SAP existe déjà.",
  settingSuccessfulSaved: "Les paramètres ont été enregistrés avec succès.",
  TimeAccountRecalculation: "Recalculer les comptes horaires",
  startTimeAccountRecalculation: "Démarrer le calcul",
  timeAccountAlreadyRecalculateError: "Recalcul des comptes horaires en cours",
  publicHolidaysAdministration: "Gestion des jours fériés",
  projectManagement: "Phases de projet",
  serviceCalls: "Intervention support client",
  permissionsAndAssignments: "Autorisations et attributions",
  searchForBusinessPartner: "Rechercher par nom ou code de partenaire",
  editProjectStagesFor: "Modifier les phases de projet pour",
  editServiceCallsFor: "Modifier les interventions support client pour",

  //Settings.vue
  stageProjectsAllowed: "Souhaitez-vous activer l'entrée de projets depuis le menu de gestion de projet ?",
  settingsWasSaved: "Les paramètres ont été enregistrés",
  stageProjectsWithoutPermissions: "Souhaitez-vous activer le système d'autorisation pour les projets depuis le menu de gestion de projet ?",
  showFinanceProjectByProjectManagement: "Souhaitez-vous afficher le nom du projet financier dans les projets entrés depuis le menu de gestion de projet ?",
  serviceCallsAllowed: "Souhaitez-vous activer l'entrée d'interventions support client ?",
  serviceCallsWithoutPermissions: "Souhaitez-vous activer le système d'autorisation pour les interventions support client ?",
  showAbsenceApprovalsInPresentList: "Afficher les demandes d'absence sur la liste de présence",
  financeProjectsAllowed: "Souhaitez-vous activer l'entrée de projets financiers ?",
  colorCode: "Code couleur",
  icon: "Icône",
  allowProjectComment: "Autoriser les commentaires sur le projet",
  showCostCentre: "Afficher les centres de coûts",
  showNewTimeCorrection: "Afficher la nouvelle correction de temps",
  hideCommentByTimeCorrection: "Masquer le champ de commentaire dans la correction de temps",
  defaultState: "Paramètres par défaut pour la région",
  showBusinessTripByTimeKeeping: "Afficher le bouton de déplacement professionnel dans le menu de saisie du temps",
  showBusinessTripByTimeKeepingOnlyIfItsApproved:
    "Afficher le bouton de déplacement professionnel dans le menu de saisie du temps si un déplacement professionnel a été approuvé pour cette date",
  startRecalculationRequest: "Êtes-vous certain(e) de vouloir lancer un recalcul des comptes horaires ? Cela peut prendre quelques minutes.",
  selectRecalculationDate: "Veuillez choisir la date à partir de laquelle les comptes horaires seront recalculés",
  resetAdminPassword: "Réinitialiser le mot de passe administrateur",
  requireLocation: "Sélection de l’emplacement obligatoire",
  chooseLocation: "Sélectionner un lieu",
  settingsTitle: "Paramètres",
  settingsTabGeneral: "Général",
  settingsTabSecurity: "Sécurité",
  settingsTabTimeManagement: "Gestion du temps",
  settingsTabProjects: "Projets",
  settingsTabServiceCalls: "Appels de service",
  settingsTabBusinessTrips: "Déplacements professionnels",
  settingsTabCalculation: "Calcul",
  timeAccountsWarningGeneral:
    "Attention : Lance un recalcul à l’échelle du système de tous les comptes de temps. Le traitement peut durer plus longtemps et affecter les performances du système. Souhaitez-vous poursuivre ?",
  startRecalculationRequest: "Démarrer le recalcul des comptes de temps ?",
  timeAccountsWarningText:
    "Attention ! Cette action lance un recalcul complet de tous les comptes de temps du système. Le traitement peut durer et ralentir temporairement l’interface.",

  //UserAdministration
  userHasNoTeam: "L'utilisateur n'est associé à aucune équipe SAP",
  userInSAPNotFound: "Utilisateur non trouvé dans SAP",
  employeeIsInactiveInSAP: "Utilisateur inactif dans SAP",
  userHasActiveTimeAccount: "L'utilisateur ne peut pas être supprimé tant qu'un compte-temps est actif.",
  userHasActiveHolidayAccount: "L'utilisateur ne peut pas être supprimé tant qu'un compte de congés est actif.",
  userDeleteMessage: "Êtes-vous certain(e) de vouloir supprimer l'utilisateur suivant :",
  holidayDeleteMessage: "Êtes-vous certain(e) de vouloir supprimer les congés suivants :",
  activateUser: "Activer l'utilisateur",
  deactivateUser: "Désactiver l'utilisateur",
  deleteUser: "Supprimer l'utilisateur",
  edit: "Modifier",
  resetPassword: "Réinitialiser le mot de passe",
  showInactiveUser: "Afficher les utilisateurs désactivés",
  hideInactiveUser: "Masquer les utilisateurs désactivés",
  usersSuccessfulDelete: "L'utilisateur a été supprimé avec succès.",
  userCodeLengthError: "Le code utilisateur ne doit pas dépasser 20 caractères",
  team: "Équipe",

  //EditUser
  validFrom: "Date de début de validité :",
  validUntil: "Date de fin de validité :",
  timeModel: "Modèle horaire",
  autoModel: "Modèle horaire automatique",
  startTimeHours: "Valeur initiale des heures",
  dateNoSelectedError: "Aucune date n'a été sélectionnée",
  vacationDays: "Dates de congé",
  userRightInfo: "L'utilisateur peut accéder au menu de saisie de temps et saisir des entrées de temps de travail.",
  projectUserRightInfo: "L'utilisateur peut saisir des entrées de temps de projet.",
  projectManagerRightInfo: "L'utilisateur peut accéder au menu de saisie manuelle de temps.",
  userManagerRightInfo: "L'utilisateur peut accéder au menu de gestion des utilisateurs et au menu de gestion des projets/interventions support client.",
  presencelistRightInfo: "L'utilisateur peut accéder à la liste de présence pour voir les collaborateurs présents appartenant à son équipe.",
  cheifPresencelistRightInfo: "L'utilisateur peut accéder à la liste de présence pour voir l'ensemble des collaborateurs présents.",
  timesCorrectionRightInfo: "L'utilisateur peut corriger le temps de travail.",
  seeTimesRightInfo: "L'utilisateur est autorisé à consulter les heures de travail d'autres collaborateurs.",
  pauseAndProjectTimeCorrectionRight: "L'utilisateur peut corriger ses propres temps de projet et de pause.",
  canChangeBusinessTripTimeInfo: "L'utilisateur peut saisir rétroactivement des déplacements professionnels.",

  notEnoughHolidaysLeft: "L'utilisateur ne dispose pas d'assez de jours de congés",
  groupSaveSuccessful: "Les groupes associés à l'utilisateur {0} ont été enregistrés avec succès.",
  editHolidayAccount: "Modifier le compte de congé",
  closingTimeAccountInPastWarning:
    "Attention, vous êtes sur le point de clôturer un ancien compte-temps. Cela va entraîner la perte de l'association des lignes d'entrée au compte-temps. L'association peut être rétablie en créant un nouveau compte-temps.",
  timeAccountForDateAlreadyExist: "Il existe déjà un compte-temps pour la date sélectionnée.",

  // UserGroups
  user: "Utilisateur",
  bookTimes: "Saisir des données de temps",
  projectTime: "Temps de projet",
  projectUser: "Utilisateur de projet",
  userManager: "Gestion des utilisateurs",
  manualTimekeeping: "Saisie manuelle de temps",
  presentListUser: "Liste de présence (équipe)",
  presentListChef: "Liste de présence (tous)",
  timeCorrection: "Corriger des données de temps",
  reviewWorkTime: "Consulter les données de temps",
  reviewWorkTimeTeam: "Consulter les données de temps (équipe)",
  projectAndPauseTimeManipulation: "Corriger les données de temps de projet et de pause",
  canChangeBusinessTripTime: "Saisir rétroactivement un déplacement professionnel",
  userRights: "Autorisations de l'utilisateur",

  // Public Holidays
  sameDateForHolidaysError: "Une absence a déjà été saisie pour la date sélectionnée",
  addNewHoliday: "Saisir un nouveau jour férié",
  deleteHolidayMessage: "Êtes-vous certain(e) de vouloir supprimer le jour férié suivant ?",
  importHolidays: "Importer des jours fériés",
  editPublicHolidays: "Modifier les jours fériés",
  holidaySuccessfulDeletedMessage: "Jours fériés supprimés avec succès",
  enterHolidayName: "Renseigner le nom du jour férié",
  sameHolidayDateError: "Une absence a déjà été saisie pour {0}.",
  holidaysWarning:
    "Attention, l'ajout ou la suppression de jours fériés à cet endroit va entraîner le recalcul de tous les comptes horaires. Cela peut prendre beaucoup de temps. Veuillez lancer ce processus uniquement si aucun utilisateur n'est connecté. Cette page vous permet de vérifier quand le processus sera terminé.",
  saveHolidayMessage: "Souhaitez-vous enregistrer ces modifications ?",
  takeOverHolidayToNextYear: "Copier sur l'année prochaine",
  timeAccountsRecalculateAlert: "Le recalcul des comptes horaires est en cours. Merci de patienter.",
  holidaysBookingProcess: "L'enregistrement des données est impossible. Le recalcul des comptes horaires est en cours.",
  holidaysNameLengthError: "Le nom du jour férié ne doit pas dépasser 100 caractères",

  // ManualTimekeeping.vue
  monthlyHistory: "Synthèse mensuelle",
  chooseProject: "Sélectionner un projet",
  chooseFinancialProject: "Sélectionner un projet financier",
  chooseCustomer: "Sélectionner un partenaire",
  chooseServiceCall: "Sélectionner une intervention support client",
  recordTime: "Saisir rétroactivement des données de temps",
  chooseProjectError: "Veuillez sélectionner un projet",
  chooseStageError: "Veuillez sélectionner une intervention support client",
  bookingError: "Attention : Le délai écoulé depuis la dernière entrée est supérieur à un jour. Veuillez renseigner la date correcte.",
  WorkAlreadyStartedError: "Le début de la journée de travail a déjà été activé",
  WorkWasNotStartedError: "Le début de la journée de travail doit d'abord être activé",
  PauseAlreadyStartedError: "Le début de la pause a déjà été activé",
  PauseWasNotStartedError: "Le début de la pause doit d'abord être activé",
  ProjectAlreadyStartedError: "Le début du projet a déjà été activé",
  ProjectWasNotStartedError: "Le début du projet doit d'abord être activé",
  financeProjects: "Projets financiers",
  selectTime: "Sélectionner l'heure",
  resetInputs: "Réinitialiser les saisies",

  //BelatedStatus
  commentIsEmpty: "Commentaire manquant",
  correctBooking: "Saisir rétroactivement une ligne",

  // Presencelist.vue
  attendancestatus: "Statut de présence",
  presentInfoText: "Un personnage ou un carton de couleur verte indique que le collaborateur est présent à son poste de travail",
  inPauseInfoText: "Un symbole représentant une tasse de café de couleur jaune indique que le collaborateur est en pause",
  absentInfoText: "Un personnage ou un carton de couleur rouge indique que le collaborateur n'est pas présent à son poste de travail",
  showLegend: "Afficher la légende",
  timeDot: "Date et heure",
  showOnlyPresentEmployee: "Afficher uniquement les collaborateurs présents",
  searchHere: "Saisir une recherche",
  switchToTableMode: "Basculer vers l'affichage tableau",
  switchToCardMode: "Basculer vers l'affichage carte",
  employeeInProject: "Le collaborateur est sur un projet",
  presentOnly: "Uniquement les personnes présentes",
  searchUser: "Chercher un utilisateur",

  // MobileQuickAccess
  quickAccess: "Accès rapide",
  savePageOrder: "L'enregistrement de la nouvelle disposition est en cours...",
  reOrderEnabled: "Vous pouvez maintenant modifier la disposition.",

  // MobileTimeReport
  vacationUsed: "Utilisé",
  vacationUnconfirmed: "Non confirmé",
  vacationOpen: "Disponible",

  // MobilePresenceList
  showFilterOptions: "Afficher les options de filtre",
  hideFilterOptions: "Masquer les options de filtrage",

  editHistory: "Modifier l'historique",
  showComments: "Afficher les commentaires",
  absenceErrorByBookingLinesCorrection: "La correction du temps est impossible. Une absence a été renseignée pour la date : {0}",
  sameTimeError: "Le délai écoulé depuis la dernière entrée est inférieur à une minute.",
  addNewBookingLine: "Ajouter une nouvelle ligne",
  presencelistInfoIsDeprecated: "Les informations de présence ne sont plus à jour",
  noTimeAccountLineForDay: "Aucun compte-temps n'est défini pour cette date",
  noRightForStartAndEndTimeCorrection: "L'utilisateur n'est pas autorisé à corriger les données de temps de début et de fin",
  noRightForPauseTimeCorrection: "L'utilisateur n'est pas autorisé à corriger les données de temps de pause",
  noRightForProjectTimeCorrection: "L'utilisateur n'est pas autorisé à corriger les données de temps de projet",

  //EmployeeInformation
  pauseTimeDebit: "Temps de pause ouvert",

  // UserSettings.vue
  enableAbsenceEmailNotifications: "Recevoir des notifications par e-mail dès qu'un membre de l'équipe demande à s'absenter",

  // Simpleclient.vue
  employee: "Collaborateur",
  employees: "Collaborateurs",
  startTime: "Heure de début",
  endTime: "Heure de fin",
  pauseStart: "Début de pause",
  pauseEnd: "Fin de pause",
  projectStart: "Début de projet",
  projectEnd: "Fin de projet",
  activityType: "Type d'activité",
  financeProject: "Projet financier",
  serviceCallBusinessPartner: "Intervention support client partenaire",
  serviceCall: "Intervention support client",
  sumWorkTime: "Total du temps de travail",
  sumPause: "Total des pauses",
  serviceCallCustomer: "Partenaire d'affaires",
  costCentre: "Centre de coûts",
  postWorktime: "Entrer du temps de travail",
  dateInFuture: "Date située dans le futur",
  dateMissing: "Date manquante",
  startTimeMissing: "Heure de début manquante",
  endTimeMissing: "Heure de fin  manquante",
  endTimeBeforeStart: "L'heure de fin doit se situer après l'heure de début",
  pauseEndBeforeStart: "L'heure de fin de pause doit se situer après l'heure de début de pause",
  pauseStartMissing: "Heure de début de pause manquante",
  pauseEndMissing: "Heure de fin de pause manquante",
  pauseStartAndEndBeforeStart: "Les heures de début et fin de pause doivent se situer après l'heure de début",
  pauseStartAndEndAfterEnd: "Les heures de début et fin de pause doivent se situer avant l'heure de fin",
  worktimeAdded: "Temps de travail ajouté",
  simpleClientErrorAbsences: "Impossible de poursuivre. Une absence a déjà été enregistrée pour cette date",
  timePeriodsOverlapError: "Fehler: Le temps saisi pour cette entrée se chevauche avec celui d'une autre entrée",
  pausesOverlapError: "Les temps de pause se chevauchent",
  effectiveTimeError: "Un temps non calculable ne doit pas être supérieur au temps de travail",
  notTimeAccountForUserError: "Aucun profil horaire n'a été créé pour cet utilisateur",
  dateOutOfTimeAccountRange: "Date située en dehors de la plage autorisée du compte-temps",
  ProjectStageNotSelected: "Phase de projet non sélectionné",
  stageIsRequired: "Phase de projet non renseignée",
  serviceCallIsRequired: "Intervention support client non renseignée",
  activityIsRequired: "Type d'activité non renseigné",

  // Start.vue
  configure: "Configurer",
  deviceMode: "Mode de l'appareil",
  terminalMode: "Mode du terminal",

  // UserMessageDialog.vue
  receivedOn: "Reçue le",
  readUnread: "Marquer comme lue / non lue",
  unread: "Non lue",
  mailUpdated: "Notification en cours de traitement",

  // AbsenceDialog.vue
  sendAbsence: "Envoyer une absence",
  requestAbsence: "Demander une absence",
  chooseAbsenceRange: "Veuillez sélectionner une période d'absence",
  absenceRequestSuccess: "Demande d'absence envoyée avec succès",
  timeRequestSuccess: "Demande de correction de temps envoyée avec succès",
  wrongFileFormat: "Format de fichier erroné",
  userHaveNoManagerOrRepresentative: "Aucun manager ou représentant n'a été créé pour l'utilisateur",

  // AbsenceCalendar.vue
  absenceType: "Types d'absence",
  colorLegend: "Légende de couleur",
  vacationRequestsConfirmed: "Demandes de congés en attente de validation",
  absenceOverview: "Vue d'ensemble des absences",
  showColorLegend: "Afficher la légende de couleur",
  absenceNeedToConfirm: "Absence en attente de validation",
  hideColorLegend: "Masquer la légende de couleur",
  normalWorkDay: "Jour ouvré normal",
  closedTimeaccountWorkDay: "Compte-temps fermé",
  showWorkTime: "Afficher le temps de travail",
  acceptAbsenceWarning: "Souhaitez-vous accepter la demande d'absence?",
  declineAbsenceWarning: "Souhaitez-vous refuser la demande d'absence?",
  absenceFromAccept: "Êtes-vous certain(e) de vouloir accepter l'absence du ",
  absenceFromDecline: "Êtes-vous certain(e) de vouloir refuser l'absence du ",
  fromTheEmployee: "du collaborateur",
  savingAbsences: "Sauvegarder des motifs d'absence dans la base de données",
  absencesSaved: "Motifs d'absence mis à jour avec succès",
  getAbsences: "Récupérer des motifs d'absence depuis le SAP",
  saveAbsence: "Sauvegarder des absences",
  absenceOverlapError: "Les absences se chevauchent",
  notEnoughVacationDays: "Le collaborateur ne dispose pas d'assez de jours de congé",
  NotEnoughVacationDaysForUser: "{0} ne dispose pas d'assez de jours de congé",

  //AbsenceOverview
  remainingHoliday: "Jours de congé restants",
  changesOverview: "Vue d'ensemble des modifications",
  addedAbsences: "Absences ajoutées",
  deletedAbsences: "Absences supprimées",
  approvedAbsences: "Absences validées",
  declinedAbsences: "Absences refusées",
  changedAbsences: "Absences modifiées",
  selectedDays: "Jours sélectionnés",
  absencesForApproval: "Absences en attente de validation",
  absenceAprrovalReasonLengthError: "Le motif ne doit pas dépasser 100 caractères",
  chooseAbsencetype: "Sélectionner une absence",
  absenceIsPast: "Modification de l'absence pour {0} impossible. La modification se situe trop loin dans le passé.",
  userHasNoTimeAccountLineForDay: "Pour l'utilisateur {0}, aucun compte-temps n'a été créé pour la date sélectionnée {1}",
  shiftSelectHint: "Maintenez Maj + Clic gauche pour sélectionner une plage de dates",

  // About.vue
  licenseValidUntil: "Licence valable jusqu'au",
  noExpiryDate: "Pas de date d'expiration",

  // History.vue
  hideDeletedBookings: "Masquer les entrées supprimées",
  showDeletedBookings: "Afficher les entrées supprimées",
  statusWorkStart: "Travail débuté",
  statusWorkEnd: "Travail fini",
  statusPauseStart: "Pause débutée",
  statusPauseEnd: "Pause finie",
  usergroups: "Groupes d'utilisateurs",
  userRights: "Droits d'utilisateur",
  getSAPUsers: "Récupérer des collaborateurs depuis la base de données SAP",
  importSAPUsers: "Importer des collaborateurs SAP",
  startPassword: "Veuillez saisir le mot de passe d'ouverture",
  noUserSelected: "Aucun utilisateur sélectionné",
  userSuccessfullyCreated: "Les utilisateurs ont été créés avec succès",
  sapExternalUser: "Numéro SAP de collaborateur externe",
  sapUserCode: "Code d'utilisateur SAP",
  startPass: "Mot de passe d'ouverture :",
  sapImport: "Importation SAP",
  name: "Nom",
  settingsSaved: "Les paramètres ont été enregistrés avec succès",
  chooseSettings: "Veuillez justifier l'ensemble des paramètres",
  timeErrorLastBookingLine: "Erreur de temps : Depuis la dernière entrée, moins d'une minute est passée. Souhaitez-vous supprimer l'entrée initiale?",
  deleteBookingLineQuestion: "Souhaitez-vous supprimer la dernière ligne?",
  startPause: "Pause débutée avec succès",
  endPause: "Pause terminée avec succès",
  endPauseTime: "Le temps de pause est de : {0}",
  startProject: "Projet : {0} débuté avec succès",
  endProject: "Projet terminé avec succès",
  startWork: "Travail débuté avec succès",
  endWork: "Travail terminé avec succès. Le temps travaillé est de : {0}",
  newProjectLogic: "Phases de projet",
  endWorkWithoutTime: "Travail terminé avec succès",
  chooseStage: "Sélectionner une phase de projet",
  chooseActivity: "Sélectionner une activité",
  stage: "Phase",
  editWorkTimeAccount: "Modifier le compte-temps",
  worktimeAccounts: "Comptes-temps",
  projects: "Projets",
  projectPermissions: "Autorisations par phases de projet",
  dataSendSuccessfully: "Données envoyées avec succès",
  timeModelDeleted: "Profil journalier supprimé avec succès",
  activeWeekModelError: "Suppression/modification impossible. Un profil hebdomadaire est associé à ce profil journalier.",
  activeTimeAccountError: "Suppression/modification impossible. Un profil journalier est associé à ce profil hebdomadaire.",
  weekModelDeleted: "Profil hebdomadaire supprimé avec succès",
  weekModelWithoutNameNotAllowed: "Profil hebdomadaire sans intitulé non autorisé",
  timeAccountIs: "Le solde du compte-temps s'élève à",
  noTimeAccountSet: "Aucun compte-temps associé",
  timeAccountNotAccurate: "Calcul du compte-temps effectué le lendemain",
  deleteTimeAccount:
    "Êtes-vous certain(e) de vouloir désactiver ce compte-temps ? Le compte sera fermé avec les temps saisis actuellement. Les entrées en attente de confirmation seront ignorées.",
  closeTimeAccount: "Fermer le compte-temps",
  absenceForDayExists: "Une absence est enregistrée pour cette date",
  workTimeHover: "Temps de travail",
  pauseTimeHover: "Temps de pause",
  projectTimeHover: "Temps de projet",
  bookedSumIs: "Heures travaillées aujourd'hui",
  bookedSumDebit: "Heures à effectuer",
  difference: "Différence",
  showOvertimeDetails: "Afficher les détails",
  hideOvertimeDetails: "Masquer les détails",
  projectStarted: "Projet {0} débuté",
  serviceCallStarted: "Intervention support client {0} débutée",
  serviceCallFinished: "Intervention support client {0} terminée",
  costCenterStarted: "Activité débutée (centre de coûts {0})",
  costCenterFinished: "Activité terminée (centre de coûts {0})",
  commentLengthError: "Le commentaire ne doit pas dépasser 400 caractères",
  saveChangeRequest: "Êtes-vous certain(e) de vouloir sauvegarder ces modifications ?",
  noProjectSelected: "Aucun projet sélectionné pour l'instant",
  noTimeAccountForDay: "Aucun compte-temps associé à cette date",
  timeSheetCannotBeEdited: "Le temps de travail pour cette date ne peut être modifié car l'entrée a déjà fait l'objet d'un décompte dans le SAP.",
  comments: "Commentaires",
  editedBy: "Modifié par",
  before: "Avant",
  after: "Après",
  on: "Le",
  at: "à",
  selectComment: "Sélectionner une commentaire",
  autoModelTip: "Entrée automatique",
  closedTimeaccount: "Compte-temps fermé",
  onSwitch: "Activé",
  offSwitch: "Désactivé",
  yes: "Oui",
  no: "Non",
  timeWasSuccessfullyCorrected: "Temps corrigé avec succès",

  // Models
  excludePeriods: "Exclures des périodes",
  deleteWeekModelMessage: "Êtes-vous certain(e) de vouloir supprimer le profil hebdomadaire {0} ?",
  everyWeek: "chaque semaine",
  everySecondWeek: "une semaine sur deux",
  everyThirdWeek: "une semaine sur trois",
  monthly: "mensuel(le)",
  editAutoWeeklyModel: "Modifier une profil automatique",
  nextAutoDayDate: "Date de l'entrée suivante",
  firstBookingDate: "Date de la première entrée",
  autoModelNextDateError: "Date de l'entrée suivante invalide pour {0}",
  autoModelChangeHint: "Modification impossible. Ce profil a déjà été associé à un utilisateur. Veuillez créer un nouveau profil.",
  autoModelChangeWarning: "Dès l'association d'un profil à un utilisateur, le profil ne peut plus être modifié. Souhaitez-vous continuer?",
  fixedBreakTimes: "Horaires de pause fixes",

  //UserProjectPermissions.vue
  projectPerms: "Autorisations et affectations par phases de projet",
  selectUserHint: "Sélectionner un utilisateur",
  selectDepartmentHint: "Sélectionner un service",
  selectUsersHint: "Transférer des autorisations aux utilisateurs suivants:",
  mirroringSubProject: "Transférer des autorisations partielles de projet aux utilisateurs sélectionnés",
  mirroringProject: "Transférer des autorisations de projet aux utilisateurs sélectionnés (seules les autorisations par phase sont transférées)",
  mirroringActivity: "Transférer des autorisations d'activité aux utilisateurs sélectionnés",
  mirroringActive: "Transférer les autorisations à d'autres utilisateurs",
  mirroringAll: "Tous",
  mirroringAllSelected: "Uniquement ceux sélectionnés",
  mirroringOnlySelectedProject: "Uniquement le projet sélectionné",
  mirroringOnlySelectedStage: "Uniquement la phase sélectionnée",
  mirroringOnlySelectedActivities: "Uniquement les activités sélectionnées",
  mirroringStage: "Transférer des autorisations de phase à d'autres utilisateurs",
  mirroringAllStages: "Toutes",
  mirroringAllActivities: "Toutes",
  chooseMirroringType: "Veuillez sélectionner les autorisations que vous souhaitez transférer :",
  userProjectPermissionSearchState: "Rechercher par état du projet",
  userProjectPermissionSearchCode: "Rechercher par code de partenaire",
  userProjectPermissionSearchName: "Rechercher par nom de partenaire",
  searchCheckbox: "Souhaitez-vous rechercher par projet ?",
  noProjects: "Aucun projet existant",
  searchDescriptionProject: "Rechercher par projet :",
  businessPartnerCode: "Code de partenaire :",
  businessPartnerName: "Nom de partenaire :",
  businessPartnerEmailAddress: "Adresse mail de partenaire :",
  permissionOnOff: "Autorisation désactivée/activéee",
  save: "Enregistrer",
  errorOnlyNumbers:
    "Dans les champs 'frais planifiés' et 'heures planifiées', seules des valeurs numériques sont autorisées. La valeur est limitée à 10 caractères et ne doit comporter ni caractères spéciaux, ni lettres",
  stateStarted: "Débuté",
  stateStopped: "Arrêté",
  statePaused: "Mis en pause",
  stateCanceled: "Interrompu/annulé",
  stateFinished: "Fini",
  plannedCosts: "Frais planifiés en ‚Ç¨ par heure",
  plannedTime: "Temps planifié en heures",
  successfullySetProjectPermissions: "Les autorisations de projet ont été créées avec succès pour",
  successfullySetServiceCallPermissions: "Les autorisations d'intervention support client ont été créées avec succès pour",
  bpInfoFor: "Information partenaire pour :",
  contactPerson: "Personne à contacter",
  postalAddress: "Adresse postale",
  standardBillingAddress: "Adresse de facturation standard",
  bpTelephone: "Téléphone du partenaire",
  fax: "Télécopie",
  email: "E-mail",
  website: "Page web",

  //UserServiceCallPermissions.vue
  serviceCallPermissions: "Autorisations et affectations pour interventions support client",
  searchTitle: "Rechercher :",
  stagesTitle: "Phases",
  serviceCallsTitle: "Interventions support client",
  serviceCallCreatedOn: "Intervention support client créée le",
  serviceCallStartedOn: "Intervention support client débutée le",
  serviceCallMustEnd: "Doit être terminée avant le",
  statusAbgeschlossen: "Terminée",
  statusOffen: "En cours",
  statusUnbekannt: "Inconnu(e)",
  statusAusstehend: "En attente",

  noServiceCalls: "Aucune intervention support client existante",
  noServiceTypes: "Aucun type d'actitivté existant",
  noBusinessPartners: "Aucun partenaire existant",
  serviceCalls: "Interventions support client",
  activityTypes: "Types d'activités",
  searchBusinessPartners: "Souhaitez-vous rechercher par partenaire ?",
  searchDescriptionServiceCall: "Rechercher par intervention support client :",
  searchDescriptionCustomer: "Rechercher par partenaire :",
  businessPartner: "Partenaire",
  userServiceCallPermissionSearchState: "Rechercher par état de l'intervention support client",
  userServiceCallPermissionSearchSubject: "Rechercher par sujet d'intervention support client",
  mirroringServiceCallSelected: "Uniquement l'intervention support client sélectionnée",
  mirroringServiceCallSelectedAll: "Tous/toutes associé(e)s à l'intervention support client sélectionnée",
  mirroringCustomerSelected: "Uniquement le partenaire sélectionné",
  mirroringCustomer: "Transférer l'intervention support client partenaire et les autorisations d'activité du/des partenaire(s) aux utilisateurs sélectionnés",
  mirroringServiceTypeSelected: "Uniquement les activités sélectionnées",
  mirroringAllSelectedCustomer: "Tous/toutes associé(e)s au partenaire sélectionné",
  mirroringServiceCall: "Transférer les autorisations d'intervention support client aux utilisateurs sélectionnés",
  mirroringServiceType: "Transférer les autorisations par type d'activité aux utilisateurs sélectionnés",
  userServiceCallPermissionSearchId: "Rechercher par ID d'intervention support client",
  userServiceCallPermissionSearchCustomerCode: "Rechercher par code de partenaire",
  userServiceCallPermissionSearchName: "Rechercher par nom de partenaire",
  //StageProjectDialog
  noProjectsWithPermission: "Aucun projet avec autorisation existant",
  noServiceCallsWithPermission: "Aucune intervention support client avec autorisation existante",

  //TimeReport
  exportBtn: "Exporter",
  exportBtnAll: "Exporter tous",
  timeReport: "Rapport de temps",
  selectTimeReport: "Sélectionner un rapport de temps",
  monthly: "Mensuel",
  timePeriod: "Période",
  timeBlocks: "Créneaux de temps",
  workingTime: "Heures de travail",
  timeIs: "Valeur réélle",
  timeDebit: "Valeur prévue",
  targetWorkTime: "Heures de travail prévues",
  timeBalance: "Solde",
  work: "Travail",
  timeIsSum: "Total réél",
  timeDebitSum: "Total prévu",
  percent: "Pour cent",
  autoModelTime: "Horaire de profil auto",
  selectAllEmployees: "Sélectionner tous les collaborateurs",

  //infoDash.vue
  selectGroupsHint: "Veuillez choisir les groupes qui verront ce message",
  help: "Aide",
  holidays: "Jours de congés annuels",
  logoNotUpdated: "Le logo n'a pas pu être modifié.",
  absenceForDateAlreadyExists: "L'absence pour cette date existe déjà.",
  absenceAccountNotExists: "Aucune absence ne peut être créée sans compte de congés.",
  holidayAccount: "Compte de congés",
  holidaysExpired: "Les jours de congés expirent l'année suivante",
  closeTimemodel: "Fermer le profil de temps",
  closeTimemodelDateWithClock: "Date de fermeture (à 00h00)",
  closeTimemodelDate: "Date de fermeture",
  createNewTimemodel: "Créer un nouveau profil de temps",
  takeOldBalance: "Reprendre le solde de temps depuis le profil de temps précédent",
  deleteTimemodelQuestion: "Êtes-vous certain(e) de vouloir fermer le profil de temps à la date indiquée ?",
  cancelDeleteTimemodelQuestion: "Êtes-vous certain(e) de vouloir annuler la fermeture du profil de temps ?",
  todayWorktime: "Heures de travail aujourd'hui",
  hrs: "Heures",
  worked: "travaillées",
  totalVacation: "Total des congés",
  open: "En cours",
  planned: "Posés",
  taken: "Pris",
  unconfirmed: "Non validés",
  days: "Jours",
  showMonthlyHistorie: "Ouvrir l'historique mensuel",
  timeAccountIsClosing: "Fermeture de compte-temps prévue.",
  timeModelNotSelected: "Le profil de temps n'a pas été sélectionné",
  deleteTimemodelNowQuestion: "Êtes-vous certain(e) de vouloir supprimer le profil de temps ?",
  openBookingLinesWillBeDeleted: "Les dernières lignes d'entrées seront supprimées",
  employeeInformation: "Afficher les informationens",
  absenceNotPossibleBookingsAvailable: "Demande d'absence impossible car il existe des entrées de temps durant la période choisie.",
  absenceForUserNotPossibleBookingsAvailable: "Demande d'absence pour {0} impossible car il existe des entrées de temps durant la période choisie.",
  absenceNotPossibleHolidayAvailable: "Demande d'absence impossible car il existe un jour férié durant la période choisie.",
  userNotFoundPasswordNotMatch: "Utilisateur non trouvé ou mot de passe erroné.",
  userIsInactiveInSAP: " Accès refusé. Utilisateur inactif dans SAP",
  dateWithAbsenceBookingNotPossible: "Pour cette date, une absence est enregistrée. Entrée de temps impossible.",
  addDailyModel: "Ajouter un profil journalier",
  addWeeklyModel: "Ajouter un profil hebdomadaire",
  addAutoWeekModel: "Ajouter un profil hebdomadaire automatique",
  saveDailyModel: "Enregistrer le profil journalier",
  saveWeeklyModel: "Enregistrer le profil hebdomadaire",
  timeIsRequired: "Le champs 'temps' ne doit pas rester vide",
  newWeeklyModel: "Nouveau profil hebdomadaire",
  newAutoWeeklyModel: "Nouveau profil hebdomadaire automatique",
  dailyModelNotSelected: "Profil journalier non sélectionné",
  weeklyModelName: "Intitulé du profil hebdomadaire",
  newDailyModel: "Nouveau profil journalier",
  timemodelName: "Intitulé du profil de temps",
  debitWorkTime: "Temps de travail prévu",
  remark: "Observation",
  worktime: "Temps de travail",
  pauses: "Pauses",
  inHours: "en heures",
  weeklyWorkTime: "Temps de travail hebdomaire",
  stages: "Phases",
  noPermission: "Pas d'autorisation",
  wrongOTPToken: "Token erroné",
  passwordSettings: "Paramétrage mot de passe",
  enable: "Activer",
  activateOTP: "Activer l'authentification à deux facteurs",
  nameIsRequired: "Nom requis",
  maximumCharacterLengthReached: "Nombre maximal de caractères dépassé",
  editDailyModel: "Modifier le profil journalier",
  editWeeklyModel: "Modifier le profil hebdomadaire",
  userHolidaysFrom: "Jours de congés à compter du {0}",
  startHolidays: "Jours de congés début de {0}",
  holidaysUsed: "Jours de congés pris",
  holidaysPlanned: "Jours de congés posés",
  holidaysBooked: "Jours de congés enregistrés",
  lastYearUserHolidays: "Congés restants de l'année précédente",
  restHolidays: "Congés restants",
  oneChangeByTimeAccount:
    "Êtes-vous certain(e) de vouloir modifier {0} ? Cela entraînera la correction de toutes les lignes d'entrées du compte. Cela peut prendre beaucoup de temps.",
  timeAccountStartValue: "la valeur de début",
  timeAccountStartDate: "la date de début",
  timeAccountModell: "le compte-temps",
  twoChangesByTimeAccount:
    "Êtes-vous certain(e) de vouloir modifier {0} ? Cela entraînera la correction de toutes les lignes d'entrées du compte. Cela peut prendre beaucoup de temps.",
  changeStartTimeAndStarDateAndWeekModel:
    "Êtes-vous certain(e) de vouloir modifier la valeur de début, la date de début et le profil de temps ? Cela entraînera la correction de toutes les lignes d'entrées du compte. Cela peut prendre beaucoup de temps.",
  timeAccountNotUpdated: "Le compte-temps n'a pas pu être modifié.",
  pinLoginNotAllowed: "Login PIN non autorisé.",
  noHolidayAccount: "Le collaborateur ne dispose d'aucun compte de congés.",
  noHolidayAccountForUser: "{0} ne dispose d'aucun compte de congés.",

  enterYearlyHolidays: "Veuillez renseigner les jours de congés annuels.",
  couldntAddOTPToUser: "OTP n'a pas pu être activé pour l'utilisateur.",
  deactivate: "Désactiver",
  activate: "Activer",
  twoFactorInfo1: "N'attendez pas pour activer l'authentification à deux facteurs.",
  twoFactorInfo2: "Son activation n'est pas difficile et vous aide à protéger votre compte de tout accès non autorisé.",
  twoFactorInfo3: "Vous aurez l'avantage en plus de pouvoir vous identifier à l'aide d'un code PIN à 4 chiffres. (+ token OTP à 6 chiffres)",
  twoFactorInfo4: "Plus besoin de retenir un mot de passe à rallonge, mais uniquement un code PIN à 4 chiffres.",
  twoFactorInfo5: "L'authentification à 2 facteurs est optionnelle, mais recommandée, car elle ajoute à votre compte une protection supplémentaire.",
  twoFactorScanCodeInfo: "Scanner le QR-Code avec votre téléphone portable et saisissez le code ci-dessous.",
  enableTwoFactor: "Activer l'authentification à 2 facteurs",
  twoFactor: "Authentification à 2 facteurs",
  status: "Etat",
  enterOTPCode: "Renseignez le mot de passe à usage unique fourni par l'application d'authentification.",
  enterCorrectStartTimeFormat: 'Format erroné ("+/- HH:mm")',
  showPin: "Afficher le code PIN",
  showPinInfo: "Êtes-vous certain(e) de vouloir afficher le code PIN ? Vérifiez qu'il soit à l'abri du regard d'autres personnes.",
  hidePin: "Masquer le code PIN",
  emptyTimeAccountOnMonthStart: "Vider le compte-temps en début de mois (p. ex. personnel intérimaire)",
  cutWorkingTime: "Couper le temps de travail",
  deductBreakTimes: "Déduire automatiquement les temps de pause imposés par la loi",
  noActiveTimeAccount: "Aucun compte-temps actif. Veuillez créer un compte pour enregistrer des créneaux de temps.",
  timeModels: "Profils de temps de travail",
  addAbsence: "Ajouter une absence",
  absenceAsAdmin: "L'absence ne peut être enregistrée en tant qu'admin.",
  removeVacation: "Supprimer congés",
  removeAbsence: "Supprimer une absence",
  addReasonAbsence: "Ajouter un motif d'absence",
  removeAbsenceQuestion: "Souhaitez-vous supprimer l'absence ?",
  addAbsenceReasons: "Ajouter des motifs d'absence",
  designation: "Intitulé",
  red: "Rouge",
  purple: "Pourpre",
  blue: "Bleu",
  cyan: "Cyan",
  indigo: "Indigo",
  violet: "Violet",
  orange: "Orange",
  deepOrange: "Orange foncé",
  brown: "Marron",
  lime: "Vert clair",
  amber: "Ambre",
  blueGrey: "Bleu-gris",
  teal: "Turquoise",
  deepPurple: "Violet foncé",
  checkInput: "Veuillez vérifier l'entrée.",
  pleaseSelectIcon: "Veuillez sélectionner une icône.",
  pleaseSelectColorCode: "Veuillez sélectionner un code couleur.",
  pleaseSelectName: "Veuillez entrer un nom.",
  chooseLocation: "Sélectionner un site",
  statusInHouse: "Sur place",
  statusOut: "En déplacement",
  statusVacation: "En congé",
  statusHomeOffice: "En télétravail",
  statusIll: "Malade",
  noDepartment: "Pas de service associé",
  statusUnknown: "Inconnu",
  addAttachment: "Joindre un document annexe",

  // Setup
  pleaseRestartServiceLayer: "Veuillez redémarrer Service Layer et ensuite valider cette boîte de dialogue. Le serveur COBI.time va alors redémarrer.",
  notInSetupMode: "Le serveur n'est pas en mode de configuration.",
  serviceNotReachablePleaseRefresh: "La connexion au service COBI.time n'a pas pu être établie. Veuillez réactualiser la page.",
  installSuccessfull: "COBI.time a été installé/actualisé avec succès. La page web va être actualisée.",
  installSuccessfullPleaseRefresh: "COBI.time a été installé/actualisé avec succès. Veuillez actualiser la page manuellement.",
  serviceLayerRestartedSuccessfully: "Service Layer a redémarré avec succès. La page web va être actualisée.",
  changelog: "Connexion / Changer d'utilisateur",
  tables: "Tableaux",
  execute: "EXECUTER",
  tableFields: "Champs",
  tableData: "Données",
  setupUpdate: "Configuration / Mise à jour",
  publicHolidayManagement: "Gestion des jours fériés",
  faceNotFound: "Le visage n'a pas été reconnu.",
  faceRecognitionDisabled: "La reconnaissance faciale est désactivée ou non configurée.",
  tryFaceLogin: "Tentative de connexion à l'aide des données faciales. Veuillez patienter...",
  deleteProfilePicture: "Supprimer la photo de profil",
  deleteProfilePictureQuestion: "Êtes-vous certain(e) de vouloir supprimer la photo de profil ?",
  showFaceHelpText: "Veuillez positionner votre visage au centre et ne pas bouger...",
  reportType: "Type de rapport",

  // Useradministration.vue
  representative: "Représentant",
  manager: "Manager",

  // StageProjectDialog
  costCenter: "Centre de coûts",
  chooseCostCenter: "Sélectionner un centre de coûts",
  // PopUpEditStages.vue
  editActivityTypes: "Ajuster les types d'activités",
  // EventLog.vue
  eventLogs: "Connexions événement",
  filterColumns: "Sélectionner des colonnes",
  filter: "Filtre",
  columnSelection: "Colonnes sélectionnées",
  breadcrumbsFilter: "Filtres sélectionnés",
  logfileExport: "Exporter le fichier journal",
  noEventLogEntries: "Aucune entrée existante pour la date indiquée",
  pageSize: "Entrées par page",
  dataRefreshed: "Données rechargées avec succès",
  timeCorrectionBy: "Correction de temps par",
  wasAssignedNewTimeAccount: "Un nouveau compte-temps a été associé",
  activeFrom: "Actif à compter du",
  dataRefreshConfirm:
    "Êtes-vous certain(e) de recharger les données ? Cela peut prendre beaucoup de temps. Vous pouvez continuer à utiliser la page durant le rechargement. Pour raccourcir le temps de chargement, vous pouvez réduire la période choisie.",
  dateRangeError: "La date de fin doit se situer après la date de début.",
  cancelled: "Annulé",
  removeBreadCrumb: "Supprimer le filtre",
  dateFrom: "A compter du",
  dateUntil: "Jusqu'au",

  //EventLog Transaction Types
  EditUserRights: "Droits d'utilisateur modifiés",
  WorkStatus: "Etat de travail",
  TimeCorrection: "Correction de temps",
  by: "par",

  // EventLog Headers
  U_severity: "Niveau",
  U_name: "Nom d'utilisateur",
  U_type: "Type de transaction",
  U_date: "Date",
  U_time: "Heure",
  U_status: "Etat",
  WorkStart: "Travail débuté",
  WorkEnd: "Travail terminé",
  PauseStart: "Pause débutée",
  PauseEnd: "Pause terminée",
  ProjectStart: "Projet débuté",
  ProjectEnd: "Projet terminé",
  details: "Détails",
  AbsenceRequest: "Demande d'absence",

  // EventLog UserEditRights
  revoked: "Révoqué",
  granted: "Accordé",
  admin: "Admin",
  user: "Utilisateur",
  projectUser: "Entrée de projet",
  manualTimeKeeping: "Saisie de temps manuelle",
  employeeManager: "Gestion des utilisateurs",
  presenceList: "Liste de présence",
  presentList: "Liste des absences",
  presenceListAll: "Liste des absences (tous)",
  timeCorrection: "Corrections de temps",
  canSeeEmployeeTimes: "Peut consulter les entrées de temps des collaborateurs",
  projectAndBreakTimeManipulation: "Modifier les temps de projet et de pause",
  canChangeBusinessTripTime: "Peut modifier les entrées de déplacements professionnels",
  userRight: "Droit d'utilisateur"
};
